import React from 'react';
import CardDeck from 'react-bootstrap/CardDeck';
import Card from 'react-bootstrap/Card';
import { Link, useParams } from 'react-router-dom';

function ResourcesPage() {
    
    return (
        <div style={{textAlign: 'left', marginLeft: '25px'}}>
            <h5 style={{marginBottom: '25px'}}>Resources:</h5>
            <p>
                Church WhatsApp Number: +44 7767 115763
            </p>
            <p>
                Church YouTube Channel: <a href="https://www.youtube.com/channel/UCf8mtPTedsQ3Yn6wFTOU4mA" target="_blank">https://www.youtube.com/channel/UCf8mtPTedsQ3Yn6wFTOU4mA</a>
            </p>
            <p>
                Online Giving Link: <a href="https://majestyhouse.square.site" target="_blank">https://majestyhouse.square.site</a>
            </p>
            <p>
                <a href="https://files.helpdocs.io/de0upq7wv8/other/1589325016828/church-online-hosts-complete-guide.pdf" target="_blank">Host Training Guide</a>               
            </p>
            <p>
                <a href="https://files.helpdocs.io/de0upq7wv8/other/1589902559589/open-co-prayer-rescources.pdf" target="_blank">Host Prayer Guide</a>               
            </p>
        </div>
    );
}

export default ResourcesPage;
